import React from 'react'

import crossSellLinksLayoutConfig from '../../config/layout/crossSellLinks'
import assetsPath from '../../common/utils/assetsPath'

const imageSrc = (path) => {
  return assetsPath() + path
}

const imageSrcSet = (paths) => {
  return paths
    .map((path) => { return imageSrc(path) })
    .join(', ')
}

const urlFor = (urlData, currentSite) => {
  return [ 'base', 'path', 'params' ].reduce((url, part) => {
    const selectedData = urlData[part][currentSite] || urlData[part]['default']

    if (part === 'params') {
      const serializedParams = Object.keys(selectedData).reduce((params, key) => {
        return params.concat(`${key}=${selectedData[key]}`)
      }, []).join('&')
      url = `${url}?${serializedParams}`
    } else {
      url = `${url}${selectedData}`
    }

    return url
  }, '')
}

export default ({currentSite}) => {
  return (
    <div className='cross-sell'>
      <div className='grid-container'>
        <ul className='cross-sell__list'>
          {
            crossSellLinksLayoutConfig.map((crossSellLink) => {
              return (
                <li key={crossSellLink.key} className='cross-sell__list-item'>
                  <a href={urlFor(crossSellLink.url, currentSite)}
                    className='cross-sell__link'>
                    <figure>
                      <picture>
                        <source media='(max-width: 480px)' srcSet='' />
                        <img src={imageSrc(crossSellLink.imageSrc)}
                          className='cross-sell__image'
                          alt={crossSellLink.label}
                          srcSet={imageSrcSet(crossSellLink.imageSrcSet)} />
                      </picture>

                      <figcaption className='cross-sell__text-container'>
                        <p className='fds-c-text-body -color-inherit -size-l -weight-bold h-mb1'
                          dangerouslySetInnerHTML={{__html: crossSellLink.heading}} />
                        <p className='fds-c-text-body -color-inherit -size-l h-m0'>
                          <small className='cross-sell__text'>
                            {crossSellLink.subHeading}
                          </small>
                        </p>
                      </figcaption>
                    </figure>
                  </a>
                </li>
              )
            })
          }
        </ul>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/components/crossSellLinksFooter.js